/**
 * Switcher component
 * Allows to switch between year and month view
 */
import React from 'react';
import PropTypes from 'prop-types';
/**
 * Stateless switcher component.
 * Renders a switcher, that consists of two buttons:
 * Year and Month.
 * Boolean value passed to switchPeriod is basically means
 * whether is currently selected button - a year button (isYearSelected)
 * @param isYearSelected
 * @param switchPeriod
 * @param cssClass
 * @constructor
 */
const Switcher = ({ isYearSelected, switchPeriod, cssClass }) => (
    <div className={`tn-switcher ${cssClass}`}>
        <button
            className={`tn-switcher__button ui-btn
                ${isYearSelected ? 'ui-btn_primary' : 'ui-btn_secondary'}`}
            onClick={() => switchPeriod(true)}
        >
            year
        </button>
        <button
            className={`tn-switcher__button ui-btn
                ${!isYearSelected ? 'ui-btn_primary' : 'ui-btn_secondary'}`}
            onClick={() => switchPeriod(false)}
        >
            month
        </button>
    </div>
);
/**
 * Prop types validation
 * @type {{isYearSelected: (any), switchPeriod: *, cssClass: *}}
 */
Switcher.propTypes = {
    isYearSelected: PropTypes.bool,
    switchPeriod: PropTypes.func.isRequired,
    cssClass: PropTypes.string
};

export default Switcher;



// WEBPACK FOOTER //
// ./src/js/common/Switcher.js